import React from "react";
import { Navbar } from "./navbar/navbar";
import {
	UserOutlined,
	LockOutlined,
	EyeInvisibleOutlined
} from "@ant-design/icons";
import { Input } from "antd";
import { useNavigate } from "react-router-dom";
import "./loginpage.css";
import "antd/dist/antd.css";
import userimg from "./userimg.png";
import user2icon from "./user2icon.png";
import usericon3 from "./usericon3.png";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Loginpage = () => {
	return (
		<div>
			<Navbar></Navbar>
			<div className="logincontainer">
				<div className="logininner">
					<span className="loginheader">Grievance Portal Login</span>
					<div className="gplunder"></div>
					<img
						src={usericon3}
						alt=""
						height={70}
						width={70}
						style={{ marginBottom: "10px" }}
					/>
					<Input
						size="large"
						placeholder="username"
						prefix={<UserOutlined />}
					/>
					<Input
						size="large"
						placeholder="password"
						prefix={<LockOutlined />}
						suffix={<EyeInvisibleOutlined />}
						// status = "error"
					/>

					<button
						className="loginpbutton"
						onClick={() => {
							toast("Login Failed", {
								type: "error",
								theme: "colored"
							});
						}}
					>
						Login
					</button>

					<ToastContainer />
				</div>
			</div>
		</div>
	);
};

export default Loginpage;
